import { StandardButton } from "../atoms/buttons";
import { VerticalPageLayout, VerticalLayout } from "../components/layout";
import { LogComp } from "../components/logComp";
import { ProfileComp } from "../components/profileComp";
import { ProgressComp } from "../components/progressComp";
import { TopBar } from "../components/topbar";
import { useContext, useEffect, useState } from "react";
import { fetchAPI, getAPI } from "../api/api";
import { PageContext, UserContext } from "../App";
import { icon } from "../functions/icons";
import { ProjectComp } from "../components/ProjectComp";
import ProfileStats from "../components/ProfileStats";
import { id } from "date-fns/locale";
import ProfileSkills from "../components/ProfileSkills";
import { Skills } from "../molecule/Skills";

export function Profile({ goCourse, pageSwap, switchPage, oldSidebar }) {
    const navigationContext = useContext(PageContext);
    const userContext = useContext(UserContext);
    const [isLoading, setLoading] = useState(true);
    const [stats, setStats] = useState({});
    const [skills, setSkills] = useState([]);
    var selectedUserId = navigationContext.sidebar.userId === 0 ? "@me" : navigationContext.sidebar.userId;
    const [user, updateUser] = useState({
        "email": "-",
        "full_name": "-",
        "phone_number": "-",
        "business": "-",
        "roles": []
    });

    const LoadUserStats = async () => {
      const query = `api/users/stats/${selectedUserId}`;
      const res = await getAPI(query);
      console.log("User Stats---:", res);
      if(res.status === "ok"){
        setStats(res.data);
      }
    };

    // const LoadUserSkills = async () => {
    //   const query = `api/users/stats/skills/${selectedUserId}`;
    //   const res = await getAPI(query);
    //   console.log("User Skills:", res);
    //   if(res.status === "ok"){
    //     setSkills(res.data);
    //   }
    // }
    async function loadData() {
        var user_information = await fetchAPI(`api/users/${selectedUserId}`);
        var user_roles = await fetchAPI(`api/users/${selectedUserId}/departments`);
        updateUser({...user_information.details, "roles": user_roles});
        setLoading(false);
} 
    useEffect(() => {
            loadData();
            LoadUserStats();
            // LoadUserSkills();
    }, [navigationContext]);

    return (
        <VerticalPageLayout className={`page-in-animation ${pageSwap && "page-out-animation"}`}>
            <ProfileComp isLoading={isLoading} allowProfileEditing={selectedUserId === "@me"} user={user} updateUser={(newUser) => updateUser(newUser)} />
              <ProfileStats stats={stats} />
              {/* <ProfileSkills skills={skills} /> */}
            { (userContext.permissions.includes("users.progress.view") || selectedUserId === "@me")&& <><ProgressComp progress title="Progressie met cursussen" endpoint={`${selectedUserId}/progress`} user={user} />
            <ProgressComp  finished={true} title="Afgeronde cursussen" endpoint={`${selectedUserId}/finished`} user={user} /></> }
            { (!userContext.permissions.includes("users.progress.view") && selectedUserId !== "@me") && <ShowLayoutError iconType={"user-cancel"} errorTitle={"Geen toegang"} message={"U kunt geen verdere gegevens bekijken van deze gebruiker."} />}
        </VerticalPageLayout>
    );
}

  function ShowLayoutError({ iconType, errorTitle, message }) {
    return (
      <VerticalLayout className="center-all complete-height">
        <span
          className="small-standard-margin"
          style={{ color: "var(--grey-500)" }}
        >
          {icon(iconType, 96)}
        </span>
        <span style={{ color: "var(--grey-800)" }}>{errorTitle}</span>
        <br />
        {message && (
          <span style={{ color: "var(--grey-600)", fontSize: "14px" }}>
            {message}
          </span>
        )}
      </VerticalLayout>
    );
  }
